import React from 'react';
export function CookiePolicy() {
  return <div className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-527">
      <h1 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-528">Cookiebeleid</h1>

      <div className="space-y-8 text-gray-700" data-id="element-529">
        <section data-id="element-530">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-531">
            1. Wat zijn cookies?
          </h2>
          <p data-id="element-532">
            Cookies zijn kleine tekstbestanden die bij het bezoeken van een
            website op uw computer of mobiel apparaat worden opgeslagen. Ze
            zorgen ervoor dat de website goed functioneert en onthouden
            bijvoorbeeld uw voorkeuren.
          </p>
        </section>

        <section data-id="element-533">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-534">
            2. Welke cookies gebruiken wij?
          </h2>
          <div className="space-y-4" data-id="element-535">
            <div data-id="element-536">
              <h3 className="font-bold text-gray-900" data-id="element-537">Noodzakelijke cookies</h3>
              <p data-id="element-538">
                Deze cookies zijn onmisbaar voor de werking van de website. Ze
                zorgen bijvoorbeeld voor de navigatie en toegang tot beveiligde
                delen.
              </p>
            </div>
            <div data-id="element-539">
              <h3 className="font-bold text-gray-900" data-id="element-540">Functionele cookies</h3>
              <p data-id="element-541">
                Deze cookies onthouden uw keuzes (zoals taalvoorkeur) om het
                gebruiksgemak te verhogen.
              </p>
            </div>
            <div data-id="element-542">
              <h3 className="font-bold text-gray-900" data-id="element-543">Analytische cookies</h3>
              <p data-id="element-544">
                Wij gebruiken Google Analytics om anoniem statistieken te
                verzamelen over het gebruik van onze website. Dit helpt ons om
                de website te verbeteren.
              </p>
            </div>
          </div>
        </section>

        <section data-id="element-545">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-546">
            3. Cookies beheren
          </h2>
          <p data-id="element-547">
            U kunt cookies weigeren of verwijderen via de instellingen van uw
            browser. Let op: het uitschakelen van cookies kan ervoor zorgen dat
            bepaalde delen van de website niet optimaal werken.
          </p>
        </section>
      </div>
    </div>;
}